"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = __importDefault(require("./"));
const vuex_module_decorators_1 = require("vuex-module-decorators");
const HttpMethodEnum_1 = require("./enums/HttpMethodEnum");
class QuestelServicesClient {
    constructor(vuexStore, baseUrl, useImpersonatingToken = false) {
        this.vuexStore = vuexStore;
        this.useImpersonatingToken = useImpersonatingToken;
        this.commonState = vuex_module_decorators_1.getModule(_1.default, this.vuexStore);
        this.baseUrl = baseUrl;
    }
    get authToken() {
        return this.useImpersonatingToken
            ? this.commonState.impersonatingAuthToken
            : this.commonState.authToken;
    }
    refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            let currentAppSettings = this.commonState.getApplicationSettings;
            let token = '';
            if (typeof (currentAppSettings) !== 'undefined' && currentAppSettings !== null) {
                if (this.useImpersonatingToken) {
                    token = yield this.get(`${currentAppSettings.ApplicationUrl + currentAppSettings.TokenRefreshPath}?` + new URLSearchParams({
                        TokenType: "ImpersonatingToken"
                    }));
                    yield this.commonState.setImpersonatingAuthToken(token);
                }
                else {
                    token = yield this.get(`${currentAppSettings.ApplicationUrl + currentAppSettings.TokenRefreshPath}?` + new URLSearchParams({
                        TokenType: "Token"
                    }));
                    yield this.commonState.setAuthToken(token);
                }
            }
            else {
                token = yield this.get(`${this.commonState.authenticationUrl}/api/serviceuser/renew`);
                if (this.useImpersonatingToken) {
                    yield this.commonState.setImpersonatingAuthToken(token);
                }
                else {
                    yield this.commonState.setAuthToken(token);
                }
            }
            return token;
        });
    }
    getCurrentMenuItems() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getJson(`${(_a = this.commonState.getApplicationSettings) === null || _a === void 0 ? void 0 : _a.ApplicationUrl}/api/UserAccount/get-cookie?` + new URLSearchParams({
                CookieName: 'CurrentMenuItems'
            }))
                .then((result) => {
                let itemValue = result.Data;
                if (itemValue !== '') {
                    let parseditems = JSON.parse(itemValue);
                    return parseditems;
                }
            })
                .catch((response) => {
                console.error(response);
                return [];
            });
        });
    }
    getCurrentToken(tokenType) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getJson(`${(_a = this.commonState.getApplicationSettings) === null || _a === void 0 ? void 0 : _a.ApplicationUrl}/api/UserAccount/get-cookie?` + new URLSearchParams({
                CookieName: tokenType
            }))
                .then((result) => {
                return result.Data;
            })
                .catch((response) => {
                console.error(response);
                return '';
            });
        });
    }
    setCurrentMenuItems(request) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.postJson(`${(_a = this.commonState.getApplicationSettings) === null || _a === void 0 ? void 0 : _a.ApplicationUrl}/api/UserAccount/generate-cookie`, request);
        });
    }
    get(url) {
        return this.getData(HttpMethodEnum_1.HttpMethodEnum.Get, url);
    }
    getPostData(url, data) {
        return this.getData(HttpMethodEnum_1.HttpMethodEnum.Post, url, data);
    }
    getData(method, url, data) {
        var result = this.sendRequest(method, url, data);
        return this.checkResponseData(result);
    }
    getJson(url, data) {
        return this.sendRequest(HttpMethodEnum_1.HttpMethodEnum.Get, url, data);
    }
    postJson(url, data) {
        return this.sendRequest(HttpMethodEnum_1.HttpMethodEnum.Post, url, data);
    }
    putJson(url, data) {
        return this.sendRequest(HttpMethodEnum_1.HttpMethodEnum.Put, url, data);
    }
    patchJson(url, data) {
        return this.sendRequest(HttpMethodEnum_1.HttpMethodEnum.Patch, url, data);
    }
    deleteJson(url, data) {
        return this.sendRequest(HttpMethodEnum_1.HttpMethodEnum.Delete, url, data);
    }
    upload(uploadUrl, files, uploadToken) {
        var request = new Request(uploadUrl, {
            method: HttpMethodEnum_1.HttpMethodEnum.Post,
            headers: {
                "Authorization": `Bearer ${this.authToken}`,
                "uploadToken": uploadToken
            },
            body: files
        });
        return fetch(request).then(response => this.handleJsonResponse(response));
    }
    download(downloadUrl, downloadToken) {
        var request = new Request(`${downloadUrl}?downloadToken=${downloadToken}`, {
            method: HttpMethodEnum_1.HttpMethodEnum.Get,
            headers: {
                "Authorization": `Bearer ${this.authToken}`,
            }
        });
        return fetch(request);
    }
    sendRequest(method, url, data) {
        var request = data ? this.getRequestWithBody(method, url, data) : this.getRequestWithoutBody(method, url);
        if (this.authToken) {
            request.headers.append('Authorization', 'Bearer ' + this.authToken);
        }
        return fetch(request).then(response => this.handleJsonResponse(response));
    }
    getRequestWithBody(method, url, data) {
        return new Request(this.baseUrl + url, {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
    }
    getRequestWithoutBody(method, url) {
        return new Request(this.baseUrl + url, {
            method: method,
            headers: { 'Content-Type': 'application/json' }
        });
    }
    checkResponseData(result) {
        return result.then(result => {
            if (result.Data == null) {
                throw result;
            }
            return result.Data;
        });
    }
    handleJsonResponse(response) {
        return response
            .json()
            .catch(() => {
            console.error('Error parsing response as JSON.');
            throw {
                Success: false,
                Message: null,
                Data: response,
                StatusCode: response.status
            };
        })
            .then(json => {
            let jsonResult = json;
            jsonResult.StatusCode = response.status;
            if (!response.ok || !json.Success) {
                throw jsonResult;
            }
            return jsonResult;
        });
    }
}
exports.QuestelServicesClient = QuestelServicesClient;
//# sourceMappingURL=QuestelServicesClient.js.map